import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { pageRoute } from "../../constant/pageRoute";

// Import Component
import { DesignSystemComponent } from "./design-system.component";

const detailsRoutes: Routes = [
    {
        path: pageRoute.designsystem.default, component: DesignSystemComponent,
        children: [
            {
                path: "",
                component: DesignSystemComponent
            },
            {
                path: pageRoute.designsystem.design.default,
                loadChildren: "./design/design.module#DesignModule"
            },
            {
                path: pageRoute.designsystem.component.default,
                loadChildren: "./component/component.module#ComponentModule"
            }
        ]
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(detailsRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class DesignSystemRoutingModule { }
